<template>
    <div v-if="!ehCercaValido" class="container-mensagem-cerca">
        <label>Para prosseguir com o lançamento de proposta, é necessário que a sua empresa possua o Certificado de
            Registro Cadastral
            <strong>emitido</strong> e <strong>válido</strong>. Por favor, verifique sua situação junto ao Cadastro de
            Fornecedores.</label>
    </div>
</template>

<script>
export default {
    name: "LicitacaoMensagemCerca",
    props: {
        ehCercaValido: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style scoped lang="stylus">

.container-mensagem-cerca
    background-color #FF5F15
    padding 10px
    color white
    border-radius 5px

</style>